__turbopack_context__.v({
  "block": "CustomRangeSection-module-scss-module__jmlqka__block",
  "label": "CustomRangeSection-module-scss-module__jmlqka__label",
  "root": "CustomRangeSection-module-scss-module__jmlqka__root",
  "rootMobile": "CustomRangeSection-module-scss-module__jmlqka__rootMobile",
  "row": "CustomRangeSection-module-scss-module__jmlqka__row",
});
